import useSharpet from 'hooks/useSharpet'
import Sharpet from './Sharpet'
import {DEFAULT_SPECIES} from './manifest'

/**
 * The signed-in member's own pet, for moments outside the corner dock
 * (success modals and toasts). Anyone without one, signed out included,
 * gets the house Shar-Pei. Reads the shared useSharpet cache, so it adds
 * no request where the dock has already loaded the pet.
 */
const MyPet = ({mood = 'happy', ...props}) => {
  const {data} = useSharpet()
  return (
    <Sharpet
      species={data?.sharpet?.species || DEFAULT_SPECIES}
      mood={mood}
      {...props}
    />
  )
}

export default MyPet
